<p-table [styleClass]="tableClass ?? 'company-table'" [value]="data" [responsiveLayout]="'scroll'" [paginator]="pagination" [rows]="pageSize" [rowsPerPageOptions]="[25, 50, 100]"
    [totalRecords]="totalCount"  [(selection)]="selectedRows" (selectionChange)="onSelectionChangeEvent($event)">

    <!-- Table Header -->
    <ng-template pTemplate="header">
        <bpc-grid-loader-line [loading]="loading"></bpc-grid-loader-line>
        <tr>
            <th pFrozenColumn *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.mappedTo : undefined" [pSortableColumnDisabled]="true">
                <span class="whitespace-nowrap">
                <p-tableHeaderCheckbox *ngIf="enableSelection && column.header === 'Company'" style="padding-right: 10px;"></p-tableHeaderCheckbox>
                <span>{{ column.header }}</span>
                <ng-container *ngIf="column.sortable">
                    <span class="fa-solid cursor-pointer ml-2 text-xs" [ngClass]="getSortClass(column)" (click)="onColumnSortClick(column)"></span>
                </ng-container>
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
            <tr [ngClass]="{
            'grid-selected-row': companyId && companyId !== row.id,
            'break-in-row': row.breakInColumn
            }">
            <td *ngFor="let column of columns">
                <ng-container *ngIf="column.case; else normalValues">
                    <div class="name-wrap">
                    <div *ngIf="row[column.mappedTo].socialLinks" class="social-wrap flex">
                        <div *ngIf="enableSelection">
                            <p-tableCheckbox 
                                [value]="row"
                                class="social-link">
                            </p-tableCheckbox>
                        </div>
                        <!--<p-tableCheckbox
                        (click)="onSelection()"
                        class="social-link"
                        *ngIf="currentTab.enableDownload && !isTablet"
                        [value]="company"
                        ></p-tableCheckbox>-->
                        <bpc-social-icon
                            *ngFor="let link of row[column.mappedTo].socialLinks"
                            class="social-links"
                            style="margin-left: 4px;"
                            [socialLink]="link"
                        >
                        </bpc-social-icon>
                    </div>
                    <div class="company-info">
                        <a
                        style="cursor: pointer;"
                        class="company-link"
                        (click)="onDetailsClick(row.id)"
                        [overlayPanelTooltip]="companyDescriptionPanel"
                        >
                        {{ row[column.mappedTo].name }}
                        </a>
                        <span *ngIf="row[column.mappedTo].city" class="company-address">
                        {{ row[column.mappedTo].city}},
                        </span>
                        <span *ngIf="row[column.mappedTo].country" class="company-address">
                         {{row[column.mappedTo].country }}
                        </span>
                        <p-overlayPanel #companyDescriptionPanel>
                            <div [innerHTML]="row[column.mappedTo].description ? row[column.mappedTo].description : 'No description available'"></div>
                        </p-overlayPanel>
                    </div>
                    </div>
                </ng-container>
                <ng-template #normalValues>
                    <div *ngIf="column.openLink==null; else fancyColumns">
                        <div *ngIf="!column.editable; else editableContent">
                            <span class="md:text-xs lg:text-sm word-wrap" [innerHTML]="row[column.mappedTo]"></span>
                        </div>
                        <ng-template #editableContent>
                            <div
                                class="flex align-items-center w-full h-full"
                                [ngClass]="{ 'cursor-pointer': isInvestmentCommitteeAdmin }"
                                (click)="onEditClick(column, row)"
                            >
                            <div class="flex align-items-center show-icon">
                                <span class="md:text-xs lg:text-sm word-wrap" [innerHTML]="row[column.mappedTo]"></span>
                                    <i  class="pi pi-pencil mx-2 text-xs cursor-pointer"></i>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    <ng-template #fancyColumns>
                        <div [ngSwitch]="column.openLink">
                            <div *ngSwitchCase="'comments'" class="star-tag txt-blue w-i mr-2" style="max-width: 70px;" (click)="showComments(row)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="20" height="20" rx="10" fill="#095A70" />
                                    <path d="M8.09383 9.79434V15H6V6.11568H8.00129V7.62532H8.1054C8.30977 7.12789 8.6356 6.73265 9.08291 6.43959C9.53406 6.14653 10.0913 6 10.7545 6C11.3676 6 11.9017 6.13111 12.3567 6.39332C12.8156 6.65553 13.1703 7.03535 13.421 7.53278C13.6754 8.03021 13.8008 8.63368 13.7969 9.34319V15H11.7031V9.66709C11.7031 9.07326 11.5488 8.60861 11.2404 8.27314C10.9357 7.93766 10.5135 7.76992 9.97365 7.76992C9.60733 7.76992 9.28149 7.8509 8.99614 8.01285C8.71465 8.17095 8.49293 8.40039 8.33098 8.70116C8.17288 9.00193 8.09383 9.36632 8.09383 9.79434Z" fill="white"/>
                                </svg>
                                <span class="ml-2 star-value f-14">{{ row.workflow ? (row.companyWorkflowCommentsLength ?? 0) : 0 }}</span>
                            </div>
                            <div *ngSwitchCase="'stats'">
                                <bpc-voting-column [row]="row"/>                        
                            </div>
                            <div *ngSwitchCase="'summary'">
                                <bpc-summary-column [row]="row"/>
                            </div>
                            <div *ngSwitchCase="'deleteCronJob'">
                                <bpc-last-execution-column [row]="row"/>
                            </div>
                            <div *ngSwitchCase="'updateCronJob'" (click)="updateCronJob(row)" style="cursor: pointer;" class="w-full">
                                <span>{{ row[column.mappedTo] }}</span>
                            </div>
                            <div *ngSwitchCase="'picture'" class="profile-image">
                                <img class="profile-image" [src]="row[column.mappedTo] ? row[column.mappedTo] : 'assets/no-image.png'" alt="{{ row.name }}" />
                            </div>
                            <div *ngSwitchCase="'editUser'">
                                <bpc-groups-column [row]="row" />
                            </div>
                            <div *ngSwitchCase="'interactionAction'" class="flex gap-2">
                                <button
                                    pButton
                                    class="p-button p-2 border-round"
                                    style="background-color: #f0f0f0; border: 1px solid #ccc; cursor: not-allowed;"
                                >
                                    <i class="pi pi-check" style="color: green;"></i>
                                </button>
                                <button
                                    pButton
                                    class="p-button p-2 border-round"
                                    style="background-color: #f0f0f0; border: 1px solid #ccc; cursor: not-allowed;"
                                >
                                    <i class="pi pi-times" style="color: #666;"></i>
                                </button>
                            </div>
                            <div *ngSwitchCase="'lastInteraction'">
                                <div *ngIf="row.latestInteraction?.interactionType" style="display: flex; align-items: center" [ngSwitch]="row.latestInteraction.interactionType">
                                    <img
                                      class="mr-2"
                                      *ngSwitchCase="interactionType.Meeting"
                                      src="assets/svg/interation-coffe.svg"
                                    />
                                    <img
                                      class="mr-2"
                                      *ngSwitchCase="interactionType.Phone"
                                      src="assets/svg/phone-icon.svg"
                                    />
                                    <img
                                      class="mr-2"
                                      *ngSwitchCase="interactionType.Email"
                                      src="assets/svg/email-icon.svg"
                                    />
                                    <img
                                      class="mr-2"
                                      *ngSwitchCase="interactionType.VideoCall"
                                      src="assets/svg/interation-video.svg"
                                    />
                                    <img
                                      class="mr-2"
                                      *ngSwitchDefault
                                      src="assets/svg/interation-notes.svg"
                                    />
                                    <span>{{ row[column.mappedTo]}}</span>
                                </div>
                            </div>
                            <div *ngSwitchDefault>
                                <span>Invalid Column Type</span>
                            </div>
                    
                        </div>
                    </ng-template>
                    
                </ng-template>
            </td>
        </tr>
    </ng-template>

    <!-- Empty Message -->
    <ng-template pTemplate="emptymessage" *ngIf="!loading">
        <tr>
            <td [colSpan]="columns.length">No data available. loader:{{loading}}</td>
        </tr>
    </ng-template>

    <!-- Table Summary -->
    <ng-template pTemplate="summary" *ngIf="pagination">
        <div class="summary">
            <strong>Total Items:</strong> {{ data.length }}
        </div>
    </ng-template>


    <ng-template pTemplate="summary">
        <ng-content></ng-content>
        <!--<bpc-paginator *ngIf="pagination" /> -->
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr *ngIf="!loading; else showSkeleton">
          <td class="no-data-container" [attr.colspan]="columns.length">
            <div class="p-table-no-data">
              <!-- <img src="assets/svg/no-data.gif" alt="No Result Found" /> -->
    
              <img src="assets/svg/search.gif" alt="No Result Found" />
              <h3>No Result Found</h3>
            </div>
          </td>
        </tr>
        <ng-template #showSkeleton>
            <tr *ngFor="let count of skeletonRowCount">
              <td *ngFor="let column of columns">
                <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              </td>
            </tr>
          </ng-template>
    </ng-template>
</p-table>
